if (!customElements.get('search-suggestions')) {
 class SearchSuggestions extends HTMLElement {
  connectedCallback() {
   this.input = this.closest('form').querySelector('input[name="q"]');
   this.handle = this.handleInputChange.bind(this);
   this.input.addEventListener('input', this.handle); this.input.addEventListener('change', this.handle);
  }
  disconnectedCallback() { clearTimeout(this.timeout); this.controller?.abort(); this.input?.removeEventListener('input', this.handle); this.input?.removeEventListener('change', this.handle); }
  handleInputChange() {
   const terms = this.input.value.trim();
   if (terms === this.oldTerms) return;
   this.oldTerms = terms; clearTimeout(this.timeout); this.controller?.abort(); this.replaceChildren();
   if (!terms) return;
   this.timeout = setTimeout(async () => {
    const controller = new AbortController(); this.controller = controller;
    try {
     const response = await fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&section_id=search-suggestions`, {signal: controller.signal});
     if (!response.ok) return;
     const text = await response.text();
     if (controller.signal.aborted || this.input.value.trim() !== terms) return;
     const results = new DOMParser().parseFromString(text, 'text/html').querySelector('.search-suggestions-wrapper');
     this.replaceChildren(); if (results?.firstElementChild) this.append(results.firstElementChild);
    } catch (error) { /* Full search remains available. */ }
   }, 300);
  }
 }
 customElements.define('search-suggestions', SearchSuggestions);
}
